const DOCUMENT_TYPE_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** True when value is a document-type master id (UUID), not a slug/code. */
export function isDocumentTypeUuid(value: string | undefined | null): boolean {
  return typeof value === 'string' && DOCUMENT_TYPE_UUID_RE.test(value.trim());
}

/** True when document is from backend checklist/predefined document set. */
export function isPredefinedDocumentType(
  documentTypeId: string | undefined | null,
  checklistItemId?: string | undefined | null,
): boolean {
  if (typeof checklistItemId === 'string' && checklistItemId.trim()) return true;
  return isDocumentTypeUuid(documentTypeId);
}

/** Resolve UUID for API `document_type_id` from draft fields. */
export function resolveDocumentTypeUuid(
  documentTypeId: string | undefined | null,
  checklistItemId?: string | undefined | null,
): string {
  const primary = typeof documentTypeId === 'string' ? documentTypeId.trim() : '';
  if (isDocumentTypeUuid(primary)) return primary;
  const fallback = typeof checklistItemId === 'string' ? checklistItemId.trim() : '';
  if (isDocumentTypeUuid(fallback)) return fallback;
  return '';
}
